var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"DayType",class:_vm.cssClass},[_c('span',{staticClass:"inner"},[_vm._v(_vm._s(_vm.output))])])}
var staticRenderFns = []

export { render, staticRenderFns }